import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import { ThemeProvider } from "next-themes";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ScrollToHash } from "@/components/ScrollToHash";

const IndustryDetail = lazy(() => import("./pages/IndustryDetail"));
const Industries = lazy(() => import("./pages/Industries"));
const About = lazy(() => import("./pages/About"));
const Privacy = lazy(() => import("./pages/Privacy"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      <ErrorBoundary>
        <TooltipProvider>
          <Toaster />
          <BrowserRouter>
            <ScrollToTop />
            <ScrollToHash />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/about" element={<Suspense fallback={<div className="min-h-screen bg-warm-cream" />}><About /></Suspense>} />
              <Route path="/industries" element={<Suspense fallback={<div className="min-h-screen bg-warm-cream" />}><Industries /></Suspense>} />
              <Route path="/industries/:slug" element={<Suspense fallback={<div className="min-h-screen bg-warm-cream" />}><IndustryDetail /></Suspense>} />
              <Route path="/privacy" element={<Suspense fallback={<div className="min-h-screen bg-warm-cream" />}><Privacy /></Suspense>} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
